// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__17DHy","dragIcon":"SortableItem_dragIcon__WqeXk","disabled":"SortableItem_disabled__2MGdz"};